'use client';
import { useLanguage } from '@/lib/i18n/LanguageContext';
export function NotWorkingCheckbox({ checked, onChange, disabled, ariaInvalid, ariaDescribedBy }: {
  checked: boolean; onChange: (v: boolean) => void; disabled?: boolean;
  /** Ties a parent-rendered error to the checkbox. */
  ariaInvalid?: boolean; ariaDescribedBy?: string;
}) {
  const { t } = useLanguage();
  return (
    <label className="inline-flex items-center gap-2 text-sm text-gray-700">
      <input type="checkbox" checked={checked} disabled={disabled} onChange={e => onChange(e.target.checked)} aria-invalid={ariaInvalid || undefined} aria-describedby={ariaDescribedBy} className="h-4 w-4 rounded border-gray-300" />
      {t('profile.notWorking')}
    </label>
  );
}
